import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useCreateParentActivity = () => {
  return useMutation((newTest) => {
    return axiosPost("/api/cw/createSelfTest", newTest);
  });
};

export default useCreateParentActivity;
